import { render, staticRenderFns } from "./FiringAlertsRSCard.vue?vue&type=template&id=14563e54&scoped=true&"
import script from "./FiringAlertsRSCard.vue?vue&type=script&lang=js&"
export * from "./FiringAlertsRSCard.vue?vue&type=script&lang=js&"
import style0 from "./FiringAlertsRSCard.vue?vue&type=style&index=0&id=14563e54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14563e54",
  null
  
)

export default component.exports